<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-row align="center">
      <v-col cols="12" lg="6">
        <v-card class="mx-3 mb-6" outlined elevation="3">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="mb-1">
                <b>Full Name : </b>
                <span>{{ profile.firstname }} {{ profile.lastname }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Email : </b> <span>{{ profile.email }}</span>
              </v-list-item-subtitle>

              <v-list-item-subtitle>
                <b>Last Login : </b> <span>{{ profile.lastlogindate }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar tile size="80">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/User_icon_2.svg/220px-User_icon_2.svg.png"
              />
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-form ref="form" lazy-validation>
      <v-row align="center">
        <v-col cols="12" lg="6">
          <v-text-field
            v-model="dataForm.firstname"
            :rules="[rules.required, rules.maxvalue]"
            class="mx-3"
            label="First Name"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
          <v-text-field
            v-model="dataForm.lastname"
            :rules="[rules.required, rules.maxvalue]"
            class="mx-3"
            label="Last Name"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
          <v-text-field
            :disabled="true"
            v-model="dataForm.email"
            class="mx-3"
            label="Email"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            :rules="[rules.required, rules.maxvaluePhone, rules.onlynumber]"
            v-model="dataForm.phonenumber"
            class="mx-3"
            label="Phone Number"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
          <v-autocomplete
            v-model="dataForm.lang.langid"
            class="mx-3"
            :items="listLang"
            dense
            label="Lang"
            outlined
            item-text="langname"
            item-value="langid"
            @change="submit"
          ></v-autocomplete>

          <v-switch
            class="mx-3"
            v-model="changePassword"
            label="Change Password"
            color="primary"
            hide-details
          ></v-switch>

          <div v-if="changePassword">
            <v-text-field
              @keyup.enter="submit"
              :rules="[rules.required, rules.maxvalue]"
              v-model="password"
              class="mx-3 mt-6"
              label="Password"
              type="Password"
              outlined
              dense
            ></v-text-field>

            <v-text-field
              @keyup.enter="submit"
              :rules="[rules.required, rules.maxvalue, rules.paswordconfirm]"
              v-model="confirmPassword"
              class="mx-3"
              label="Password Confirm"
              outlined
              type="Password"
              dense
            ></v-text-field>
          </div>
          <v-btn
            @click="submit"
            depressed
            color="primary"
            class="mx-3 float-sm-right"
            :loading="loadingUpdate"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        maxvalue: (value) =>
          value.length <= 32 || "Maximum length is 32 characters",
        maxvaluePhone: (value) =>
          value.length <= 20 || "Maximum length is 20 characters",
        onlynumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) || "Value Only Number",
        paswordconfirm: () =>
          this.password == this.confirmPassword || "password not confirm",
      },

      breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "My Profile",
        disabled: true,
      },
    ],


      loadingUpdate: false,
      changePassword: false,
      profile: {},
      dataForm: {
        lang: "",
        firstname: "",
        lastname: "",
        phonenumber: "",
      },
      listLang: [],

      password: "",
      confirmPassword: "",
    };
  },

  components: {
    Breadcrumbs,
  },
  mounted() {
    this.getMyProfile();
    this.getAllLang();
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        this.loadingUpdate = true;
        let DataForm = {
          Param: {
            firstname: this.dataForm.firstname,
            lastname: this.dataForm.lastname,
            langid: this.dataForm.lang.langid,
            phonenumber: this.dataForm.phonenumber,
          },
          API: "/admin/my",
        };
        if (this.changePassword == true) {
          DataForm.Param.password = this.password;
        }
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then((response) => {
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.loadingUpdate = false;
            if (this.changePassword == true) {
              localStorage.removeItem("token");
              localStorage.removeItem("name");
              this.$store.commit("destroyToken");
              this.$router.push({ name: "Logout" }).catch(() => {});
              this.$parent.$parent.$children[0].drawer = false;
            } else {
              this.getMyProfile();
            }
          })
          .catch((error) => {
            this.loadingUpdate = false;
            this.$store.dispatch("PushErrorMsg", error.data.message);
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getMyProfile() {
      this.$store.dispatch("GetFromAPI", "/admin/my").then((response) => {
        this.profile = response["data"]["data"];
        this.dataForm = { ...this.profile };
        var date = new Date(this.profile.lastlogindate);
        let LoginDate = "";
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        LoginDate =
          day + "/" + month + "/" + year + " " + date.toLocaleTimeString();
        this.profile.lastlogindate = LoginDate;
      });
    },

    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.listLang = response["data"]["data"];
      });
    },
  },
};
</script>
